import type { MesPyg } from './tipos'
import estilos from './PygProyectos.module.css'

function formatoPesos(valor: number): string {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(Math.round(valor))
}

type Props = {
  meses: MesPyg[]
  mesActualClave: string
}

export function TablaResultadosMensual({ meses, mesActualClave }: Props) {
  if (meses.length === 0) return null

  return (
    <div className={estilos.cardTabla}>
      <div className={estilos.tablaWrapper}>
        <table className={estilos.tablaPyg} aria-label="Estado de resultados mensual">
          <thead>
            <tr>
              <th>Mes</th>
              <th className={estilos.colNum} title="Dinero efectivamente cobrado que entró a caja en este mes (Tarea 2.9)">
                Lo Cobrado (Caja)
              </th>
              <th className={estilos.colNum} title="Costos directos incurridos en este mes">
                Costos del Mes
              </th>
              <th className={estilos.colNum} title="Utilidad de ESE mes (Cobrado menos Costos de ese mes)">
                Utilidad Periodo
              </th>
              <th className={estilos.colNum} title="Margen sobre lo efectivamente cobrado en el mes">
                Margen s/ Cobrado
              </th>
              <th className={estilos.colNum} title="Margen sobre el valor total contratado de la obra">
                Margen s/ Contratado
              </th>
              <th className={estilos.colNum} title="Cuota de administración y campamento repartida a prorrata de lo ejecutado (Tarea 2.11)">
                Indirectos (Prorrata)
              </th>
              <th className={estilos.colNum} title="Margen directo (dice si la obra se defiende sola en terreno)">
                Margen Directo
              </th>
              <th className={estilos.colNum} title="Margen neto después del reparto de administración central">
                Margen Neto
              </th>
              <th className={estilos.colNum} title="Utilidad acumulada desde que arrancó la obra">
                Acumulado Obra
              </th>
            </tr>
          </thead>
          <tbody>
            {meses.map((m) => {
              const esActual = m.clave === mesActualClave
              const utilPeriodoPositiva = m.utilidadPeriodo >= 0
              const utilNetoPositiva = m.margenNeto >= 0

              return (
                <tr
                  key={m.clave}
                  className={esActual ? estilos.filaMesActual : m.futuro ? estilos.filaMesFuturo : undefined}
                >
                  <td>
                    <b>{m.etiqueta}</b>
                    {esActual && (
                      <span className={estilos.badgeProyCodigo} style={{ marginLeft: 8, fontSize: '0.7rem' }}>
                        En curso
                      </span>
                    )}
                    {m.futuro && (
                      <span style={{ marginLeft: 8, fontSize: '0.7rem', color: '#94a3b8' }}>
                        Previsto
                      </span>
                    )}
                  </td>
                  <td className={estilos.colNum}>
                    <b style={{ color: m.cobradoMes > 0 ? '#059669' : '#64748b' }}>
                      {m.futuro ? '—' : formatoPesos(m.cobradoMes)}
                    </b>
                  </td>
                  <td className={estilos.colNum} style={{ color: '#c2334d' }}>
                    {m.futuro ? '—' : formatoPesos(m.costoDirecto)}
                  </td>
                  <td className={estilos.colNum}>
                    <b style={{ color: utilPeriodoPositiva ? '#166534' : '#c2334d' }}>
                      {m.futuro ? '—' : formatoPesos(m.utilidadPeriodo)}
                    </b>
                  </td>
                  <td className={estilos.colNum}>
                    {m.futuro ? '—' : `${m.margenSobreCobradoPct}%`}
                  </td>
                  <td className={estilos.colNum}>
                    {m.futuro ? '—' : `${m.margenSobreContratadoPct}%`}
                  </td>
                  <td className={estilos.colNum} style={{ color: '#d97706' }}>
                    {m.futuro ? '—' : formatoPesos(m.indirectosProrrateados)}
                  </td>
                  <td className={estilos.colNum} style={{ color: m.margenDirecto >= 0 ? '#166534' : '#c2334d' }}>
                    {m.futuro ? '—' : formatoPesos(m.margenDirecto)}
                  </td>
                  <td className={estilos.colNum}>
                    <b style={{ color: utilNetoPositiva ? '#166534' : '#c2334d' }}>
                      {m.futuro ? '—' : `${formatoPesos(m.margenNeto)} (${m.margenNetoPct}%)`}
                    </b>
                  </td>
                  <td className={estilos.colNum}>
                    <b style={{ color: m.utilidadAcumulada >= 0 ? '#166534' : '#c2334d' }}>
                      {m.futuro ? '—' : formatoPesos(m.utilidadAcumulada)}
                    </b>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
